export default __webpack_public_path__ + "static/media/ps-LampPost.84e43589.png";